import { Pipe, PipeTransform, Inject } from '@angular/core';
import * as momentNs from 'moment-timezone';

// moment-timezone 0.6 typings use TS 2.8+ syntax. This project typechecks with TS 2.2.
const moment: any = momentNs;

@Pipe({
  name: 'timezoneFormat'
})

export class TimezoneFormatPipe implements PipeTransform {
  constructor() {}

  transform(time: any, group: any): string {
    if (!!time) {
      if (parseInt(moment().tz(moment.tz.guess()).format('Z')) !== group.timezone.utcOffset) {
        return moment(time).tz(group.timezone.name).format('HH:mm z');
      }
      return moment(time).format('HH:mm');
    }
    return time;
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/pipes/timezone-format.pipe.ts